import { render } from "./AboutUs.vue?vue&type=template&id=a5938092&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=js"
export * from "./AboutUs.vue?vue&type=script&lang=js"

import "./AboutUs.vue?vue&type=style&index=0&id=a5938092&lang=less&scoped=true"

import exportComponent from "C:\\project\\famous-build-en\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5938092"]])

export default __exports__